var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.396 5.522a2.063 2.063 0 0 0-2.918-2.918L2.604 26.478a2.063 2.063 0 1 0 2.918 2.918L29.396 5.522zM14.512 3.783a2.063 2.063 0 0 1 0 2.918L6.554 14.66a2.063 2.063 0 0 1-2.918-2.919l7.958-7.957a2.063 2.063 0 0 1 2.918 0zm13.705 13.853a2.063 2.063 0 0 1 0 2.918l-7.958 7.957a2.063 2.063 0 0 1-2.919-2.916l7.96-7.958a2.063 2.063 0 0 1 2.917 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGal);
export default __webpack_public_path__ + "static/media/GAL.9c3c8ca23148306212dadf7d94870e8c.svg";
export { ForwardRef as ReactComponent };